import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../../UI/Typography'
import ScrollNav from '../../UI/ScrollNav'
import SplitSection from '../../UI/Slider/SplitSection'
import Button from '../../UI/Button'
import TabSlider from '../../UI/TabSlider'
import { device } from '../../../utils/helpers'
import { Element, Events } from 'react-scroll'

import Feature from '../../UI/Feature'
import { features } from './Contenimento'

import {
  calcettoSlides1,
  calcettoSlides2,
  calcettoSlides3,
  calcettoSlides4
} from '../../Helpers/Slides'

import {
  Section,
  Title,
  BigTitle,
  FeatureWrapper,
  Features,
  Menu,
  Content
} from './Altre'

import CalcettoIcon from '../../UI/Icons/CalcettoIcon'
import GabbiaIcon from '../../UI/Icons/GabbiaIcon'

const Icon = ({ icon, ...props }) => (
  // Needed to pass props to the element which is also being
  // passed as props
  React.cloneElement(icon, { ...props })
)

const StyledIcon = styled(Icon)`
  width: ${props => props.width};
  height: ${props => props.height};

  @media ${device.tablet} {
    width: ${props => props.tabWidth};
    height: ${props => props.tabHeight};
  }
`

const navItems = [
  {
    name: 'Calcetto',
    icon: <StyledIcon icon={<CalcettoIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Gabbia',
    icon: <StyledIcon icon={<GabbiaIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  }
]

export const calcetto = {
  description: 'Un verde acceso unito ai soffici 3,5 cm di erba sintetica di ultima generazione rendono l’esperienza di gioco molto simile a quella di un campo a installazione fissa.;L’altezza dell’erba oltre a generare un grip migliore per gli atleti ammortizza il contatto con la superficie sottostante in modo performante.',
  tabs: [
    {
      title: 'Erba',
      content: 'Materiali dotati di certificazione;Manto erboso di ultima generazione (altezza 3,5 cm);Non necessita di ancoraggio al suolo',
      goToSlideIndex: 0
    },
    {
      title: 'Porte',
      content: 'Coppia di porte Calcio 5vs5 (3x2 mt);Coppia di porte Calcio 7vs7 (5x2 mt)',
      goToSlideIndex: 1
    }
  ]
}

export const gabbia = {
  description: 'La gabbia 2vs2 e 3vs3 è una modalità di gioco veloce e dinamica.;Le porticine senza portiere, il gioco di sponda e la palla sempre in gioco sono le regole fondamentali per l’organizzazione di un torneo in stile street soccer.;Il rapido montaggio e le dimensioni ridotte della struttura permettono l’installazione in location originali come piazze storiche, centri commerciali, spiagge etc etc.',
  tabs: [
    {
      title: 'SUPERFICIE DI GIOCO',
      content: 'Materiali dotati di certificazione;Manto erboso di ultima generazione/superficie tecnica',
      goToSlideIndex: 2
    },
    {
      title: 'Struttura',
      content: 'Non necessita di ancoraggio al suolo;Bordo campo brandizzabili;Recinzione integrale (reti) dell’area di gioco (tetto incluso);Impianto di illuminazione;Impianto audio e diffusione sonora',
      goToSlideIndex: 0
    },
    {
      title: 'Dimensioni',
      content: <div>
        <Typography variant='h5' type='subtitle'>CALCIO 2vs2</Typography>
        <span>12×6 m (ingombro 14×8 m)</span><br />
        <span>n° 2 porte con rete in nylon/ferro</span><br /><br />
        <Typography variant='h5' type='subtitle'>CALCIO 3vs3</Typography>
        <span>16×9 m (ingombro 18×10 m)</span><br />
        <span>n° 2 porte con rete in nylon/ferro</span><br />
      </div>,
      goToSlideIndex: 0
    }
  ]
}

const SubSection = styled.div`

  @media ${device.laptopL} {
    display: flex;
    justify-content: space-between;
  }
`

class CampoCalcetto extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sticky: false
    }
  }

  componentDidMount () {
    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })

    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll (event) {
    const sticky = this.menu && this.menu.offsetTop
    console.log(window.pageYOffset, sticky)
    if (window.pageYOffset > sticky - 100) {
      this.setState({ sticky: true })
    }

    if (window.pageYOffset < 165) {
      this.setState({ sticky: false })
    }
  }

  render () {
    return (
      <div>
        <Helmet>
          <title>Campi da calcetto</title>
          <meta name='Description' content='Noleggio attrezzature sportive per campi da calcetto in erba sintetica, soccer arena e porte calcetto!' />
          <meta name='Keywords' content='campo calcetto sintetico prezzi,porte da calcetto,calcetto smontabile' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>CAMPO DA CALCETTO</Typography>
        </Title>
        <Menu innerRef={menu => (this.menu = menu)} className={this.state.sticky ? 'sticky' : ''}>
          <ScrollNav items={navItems} />
        </Menu>
        <Content>
          {/* CALCETTO */}
          <Element name='calcetto' >
            <SplitSection slides={calcettoSlides1} reverse reverseMobile>
              <Typography variant='h2' type='title'>CALCETTO</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {calcetto.description.split(';').map(line => <span>{line}<br /></span>)}
              </Typography>
              <SubSection>
                <div>
                  <Typography padding='1.2rem 0' variant='h5' type='title'>Tipologie</Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ paddingRight: '10px' }}>
                      <span>CALCETTO 5vs5</span> <br />
                      <span style={{ color: '#999999' }}>Min: 25x15 m (ingombro 27x15 m)</span> <br />
                      <span style={{ color: '#999999' }}>Max: 32x20 m (ingombro 34x22 m)</span> <br />
                      <span style={{ color: '#999999' }}>Standard: 30x18 m (ingombro 32x20 m)</span> <br />
                    </div>
                    <div>
                      <span>CALCETTO 7vs7</span> <br />
                      <span style={{ color: '#999999' }}>Min: 46x26 m (ingombro 50x30 m)</span> <br />
                      <span style={{ color: '#999999' }}>Max: 60x40 m (ingombro 66x44 m)</span> <br />
                      <span style={{ color: '#999999' }}>Standard: 48x28 m (ingombro 52x32 m)</span> <br />
                    </div>
                  </div>
                </div>
              </SubSection>
            </SplitSection>
            <TabSlider
              slides={calcettoSlides2}
              tabs={calcetto.tabs}
              title='Dettagli Tecnici'
              customize
            >
              <div>
                <Typography padding='1.2rem 0' variant='h5' type='title'>NOLEGGIA UN CAMPO PER IL TUO EVENTO!</Typography>
                <Button size='small' primary to='/noleggia/calcetto/1'>CREA PREVENTIVO</Button>
              </div>
            </TabSlider>
          </Element>
          {/* GABBIA */}
          <Element name='gabbia' >
            <SplitSection slides={calcettoSlides3} reverse>
              <Typography variant='h2' type='title'>GABBIA 2vs2 / 3vs3</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {gabbia.description.split(';').map(line => <span>{line}<br /></span>)}
              </Typography>
              <SubSection>
                <div>
                  <Typography padding='1.2rem 0' variant='h5' type='title'>NOLEGGIA UN CAMPO <br /> PER IL TUO EVENTO!</Typography>
                </div>
                <div>
                  <Button size='small' primary to='/noleggia/calcetto/2?variant=1'>CREA PREVENTIVO</Button>
                </div>
              </SubSection>
            </SplitSection>
            <TabSlider
              slides={calcettoSlides4}
              tabs={gabbia.tabs}
              title='Dettagli Tecnici'
            />
          </Element>
        </Content>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              4 BUONI MOTIVI PER SCEGLIERE LE NOSTRE STRUTTURE
            </Typography>
          </BigTitle>
          <Features>
            {features.map(feature => (
              <FeatureWrapper>
                <Feature
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </FeatureWrapper>
            ))}
          </Features>
        </Section>
      </div>
    )
  }
}

export default CampoCalcetto



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/CampoCalcetto.js